//extracted by mini-css-extract-plugin
export default {"noResult":"noResult_noResult__3IGH7"};;